
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const DronesPage = lazy(() => import('../pages/drones/page'));
const AutoSteeringPage = lazy(() => import('../pages/auto-steering/page'));
const AgrasT70PPage = lazy(() => import('../pages/agras-t70p/page'));
const AgrasT25PPage = lazy(() => import('../pages/agras-t25p/page'));
const AgrasT25Page = lazy(() => import('../pages/agras-t25/page'));
const AgrasT10Page = lazy(() => import('../pages/agras-t10/page'));
const Mavic3MPage = lazy(() => import('../pages/mavic-3m/page'));
const FjdAt2Page = lazy(() => import('../pages/fjd-at2/page'));
const FjdAt2MaxPage = lazy(() => import('../pages/fjd-at2-max/page'));
const FjdAl02Page = lazy(() => import('../pages/fjd-al02/page'));
const FjdAtsPage = lazy(() => import('../pages/fjd-ats/page'));
const ESteer20MaxPage = lazy(() => import('../pages/esteer-20-max/page'));
const ESteer20Page = lazy(() => import('../pages/esteer-20/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const MatsugumaCasePage = lazy(() => import('../pages/case-studies/matsuguma-farm/page'));
const KoyanagiCasePage = lazy(() => import('../pages/case-studies/koyanagi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));

import WaterManagementPage from '../pages/water-management/page';
import About from '../pages/about/page';
import SchoolPage from '../pages/school/page';
import LocationsPage from '../pages/locations/page';
import MaintenanceServicePage from '../pages/maintenance-service/page';
import ContractSpraying from '../pages/contract-spraying/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/drones',
    element: <DronesPage />
  },
  {
    path: '/auto-steering',
    element: <AutoSteeringPage />
  },
  {
    path: '/auto-steering/fjd-at2',
    element: <FjdAt2Page />
  },
  {
    path: '/auto-steering/fjd-at2-max',
    element: <FjdAt2MaxPage />
  },
  {
    path: '/auto-steering/fjd-al02',
    element: <FjdAl02Page />
  },
  {
    path: '/auto-steering/fjd-ats',
    element: <FjdAtsPage />
  },
  {
    path: '/auto-steering/esteer-20-max',
    element: <ESteer20MaxPage />
  },
  {
    path: '/auto-steering/esteer-20',
    element: <ESteer20Page />
  },
  {
    path: '/agras-t10',
    element: <AgrasT10Page />
  },
  {
    path: '/agras-t25',
    element: <AgrasT25Page />
  },
  {
    path: '/agras-t25p',
    element: <AgrasT25PPage />
  },
  {
    path: '/agras-t70p',
    element: <AgrasT70PPage />
  },
  {
    path: '/mavic-3m',
    element: <Mavic3MPage />
  },
  {
    path: '/water-management',
    element: <WaterManagementPage />
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />
  },
  {
    path: '/case-studies/matsuguma-farm',
    element: <MatsugumaCasePage />
  },
  {
    path: '/case-studies/koyanagi',
    element: <KoyanagiCasePage />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/school',
    element: <SchoolPage />
  },
  {
    path: '/locations',
    element: <LocationsPage />
  },
  {
    path: '/maintenance-service',
    element: <MaintenanceServicePage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/contract-spraying',
    element: <ContractSpraying />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
